/**
 * Set-up deflection tool with adapted configuration if contact form is
 * detected on the page
 *
 * @param {object} app
 * @param {InbentaKmSDK} InbentaKmSDK
 * @param {KmSDKConfig} sdkConfig
 */
export default function (app, InbentaKmSDK, sdkConfig) {
  // Set up deflection on contact form
  const commentBox = document.querySelector('#commentaire');
  if (commentBox) {
    // Same conf as KM but with different userType
    var deflectionConf = sdkConfig;
    deflectionConf.userType = 2;
    deflectionConf.source = 'deflection';

    // Create SDK object
    var deflectionSdk = InbentaKmSDK.createFromDomainKey(app.sdkAuth.domainKey, app.sdkAuth.inbentaKey, deflectionConf);
    var deflection = deflectionSdk.component('deflection', '#deflection', {
      labels: {
        INSTANTS_TITLE: 'Ces réponses peuvent vous intéresser',
      },
      contents: {
        openContentOnClick: false,
      },
      debounceTime: 250,
      triggers: ['.', ',', ':', ';', '(', ')', '¿', '?', '¡', '!', ' ']
    });
    deflection.linkToInput(commentBox);
    deflection.$on('click', function (content) {
      // Handle tracking
      let query = commentBox.value;
      deflectionSdk.client.search(query, {
        length: 3
      }).then(function (response) {
        response.data.results.forEach(function (element) {
          if (element.id === content.id) {
            deflectionSdk.client.track('click', { code: element.tracking.clickCode });
            window.activeRateCode = element.tracking.rateCode;
          }
        });
        window.searchCode = response.data.tracking.searchCode;
        window.open(`${sdkConfig.helpsiteURL.replace(/\/$/, '')}/content/${content.slug}/?o=gp`, '_blank');
      });
    });

    // The test page has no form submit button
    const submitButton = document.querySelector('#submit-contact-btn');
    if (submitButton) {
      document.querySelector('#submit-contact-btn').parentElement.addEventListener('submit', function () {
        const userQuery = commentBox.value;
        deflectionSdk.client.track('contact_ticket', {
          value: userQuery
        });
        deflectionSdk.client.track('search_rate', {
          code: window.searchCode,
          value: 4,
          comment: userQuery
        });
      }, {
        // Before sending
        capture: true,
        // Only once
        once: true
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/helpers/deflection-init.js